import { SNS } from '../interfaces/common'

export interface TokenPriceWithChange {
  [tokenId: string]: {
    price: number
    priceChange: number
    volume24h?: number
  }
}

export interface DefiToken {
  symbol: string
  volume: number
}

export interface Locale {
  id: string
  currency: {
    code: string
    symbol: string
    name: string
    usdExchangeRate: number
  }
  numberFormat?: string
  flagEmoji: string
}

export interface WebApp {
  title: string
  logo: string
  url: string
}

class CacheClient {
  private async request<T>(url: string) {
    const result = await fetch(url, { cache: 'no-cache' })

    if (result.ok) {
      return result.json() as Promise<T>
    } else {
      throw await result.text()
    }
  }

  getTokenPrices(): Promise<TokenPriceWithChange> {
    return this.request('https://plug-cache.s3.amazonaws.com/v2/token-prices.json')
  }

  getSns(): Promise<SNS[]> {
    return this.request('https://plug-cache.s3.amazonaws.com/v2/sns.json')
  }

  getTop5Tokens(): Promise<DefiToken[]> {
    return this.request('https://plug-cache.s3.amazonaws.com/v2/top-5.json')
  }

  async getLocales(): Promise<Locale[]> {
    return this.request('https://plug-cache.s3.amazonaws.com/v2/locales.json')
  }

  getDappUrls(): Promise<WebApp[]> {
    return this.request('https://plug-cache.s3.amazonaws.com/webAppUrls.json')
  }
}

export default CacheClient
